/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import DiplomesVatel from "../assets/images/vatel/45000-diplomes-vatel.png";
import ok from "../assets/images/svg/ok.svg";

const Testimonials = () => {
  return (
    <div className=" section-padding bg-[url('../images/all-img/section-bg-16.png')] bg-cover  bg-no-repeat lg:mt-[136px]">
      <div className="container lg:-mt-[250px] xl:pb-[136px] lg:pb-20 pb-10">
        <div
            className="grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-[30px] bg-white shadow-box14 rounded-md
                divide-x-2 divide-[#E4EEED] py-10"
        >
          <div className=" text-center ">
            <h2 className="text-secondary font-bold ">
              <span className=" counter">50</span>+
            </h2>
            <span className="block text-black font-semibold">
              Campus
            </span>
          </div>

          <div className=" text-center">
            <h2 className="text-secondary font-bold ">
              <span className=" counter">1</span><sup>er</sup>
            </h2>
            <span className="block text-black font-semibold">
              Groupe mondial de l'Enseignement du Management de l'Hôtellerie-Tourisme
            </span>
          </div>
          <div className="  text-center">
            <h2 className="text-secondary font-bold ">
              <span className=" counter">9000</span>+
            </h2>
            <span className="block text-black font-semibold">
              Etudiants
            </span>
          </div>
          {/*<div className="  text-center">
            <h2 className="text-secondary font-bold ">
              <span className=" counter">45 000</span>+
            </h2>
            <span className="block text-black font-semibold">
              Diplômés
            </span>
          </div>*/}
          <div className="  text-center">
            <h2 className="text-secondary font-bold ">
              <span className=" counter">1</span><sup>re</sup>
            </h2>
            <span className="block text-black font-semibold">
              Sacrée Meilleure Ecole par les professionnels
            </span>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="grid grid-cols-12 lg:gap-10 gap-6 ">
          <div className="xl:col-span-7 lg:col-span-6 col-span-12">
            <img src={DiplomesVatel} alt="" draggable="false"/>
          </div>
          <div className="xl:col-span-5 lg:col-span-6 col-span-12 flex flex-col justify-center ">
            <div className="mini-title">Devenez un profil très recherché</div>
            <h4 className="column-title tw-leading-tight">
              <span className="shape-bg">50 000</span> diplômés à travers le monde
            </h4>
            <div>
              Les profils des diplômés Vatel, à la fois stratégiques et opérationnels, sont très appréciés des
              recruteurs.
              Très prisés non seulement dans l’hôtellerie, la restauration, le tourisme mais aussi le luxe, la
              joaillerie, le digital, l’agro-alimentaire, les services à la personne…, les Vatéliens accèdent à des
              fonctions variées.
              <br/>
              <br/>
              Que ce soit au sein de <strong>cafés hôtel-restaurant (CHR)</strong>, de <strong>palaces</strong>,
              d’agences de voyages... voici quelques exemples de <strong>métiers
              de l’hôtellerie-restauration</strong> envisageables :
            </div>

            <ul className="space-y-2 pt-8">
              <li className="flex flex-wrap">
                <div className="flex-none mr-3">
                  <div className="">
                    <img src={ok} alt=""/>
                  </div>
                </div>
                <div className="flex-1">
                  <h4 className="text-lg mb-1 font-semibold">
                    Brand Manager
                  </h4>
                </div>
              </li>

              <li className="flex flex-wrap">
                <div className="flex-none mr-3">
                  <div className="">
                    <img src={ok} alt=""/>
                  </div>
                </div>
                <div className="flex-1">
                  <h4 className="text-lg mb-1 font-semibold">
                    Maître d'Hôtel
                  </h4>
                </div>
              </li>

              <li className="flex flex-wrap">
                <div className="flex-none mr-3">
                  <div className="">
                    <img src={ok} alt=""/>
                  </div>
                </div>
                <div className="flex-1">
                  <h4 className="text-lg mb-1 font-semibold">
                    Sales Manager
                  </h4>
                </div>
              </li>

              <li className="flex flex-wrap">
                <div className="flex-none mr-3">
                  <div className="">
                    <img src={ok} alt=""/>
                  </div>
                </div>
                <div className="flex-1">
                  <h4 className="text-lg mb-1 font-semibold">
                    Directeur d'Écolodge
                  </h4>
                </div>
              </li>

              <li className="flex flex-wrap">
                <div className="flex-none mr-3">
                  <div className="">
                    <img src={ok} alt=""/>
                  </div>
                </div>
                <div className="flex-1">
                  <h4 className="text-lg mb-1 font-semibold">
                    Manager Luxe
                  </h4>
                </div>
              </li>

              <li className="flex flex-wrap">
                <div className="flex-none mr-3">
                  <div className="">
                    <img src={ok} alt=""/>
                  </div>
                </div>
                <div className="flex-1">
                  <h4 className="text-lg mb-1 font-semibold">
                    Responsable Événementiel
                  </h4>
                </div>
              </li>

              <li className="flex flex-wrap">
                <div className="flex-none mr-3">
                  <div className="">
                    <img src={ok} alt=""/>
                  </div>
                </div>
                <div className="flex-1">
                  <h4 className="text-lg mb-1 font-semibold">
                    Négociant en Vins & Spiritueux
                  </h4>
                </div>
              </li>
            </ul>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
